export default __webpack_public_path__ + "static/media/maskgroup.77b76918.svg";